import { render } from "./UploadKnowledgeModal.vue?vue&type=template&id=52367f82&scoped=true"
import script from "./UploadKnowledgeModal.vue?vue&type=script&lang=js"
export * from "./UploadKnowledgeModal.vue?vue&type=script&lang=js"

import "./UploadKnowledgeModal.vue?vue&type=style&index=0&id=52367f82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52367f82"]])

export default __exports__